import { debounce } from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import proposalsApi from '../../APIs/proposals';
import {
  Button,
  PageHeader,
  Pagination,
  Table,
  Tabs,
} from '../../designComponents';
import { TableDataType } from '../../designComponents/Table';
import { VIEW_PROPOSAL_ROUTE } from '../../routes/routePaths';
import Store from '../../store';
import { RootState } from '../../store/selectors';
import theme from '../../theme';
import { requestAPI } from '../../utils';
import { MyParamsType } from '../Building';
import { ProposalsListingContainerStyled } from './style';

type ParamsType = {
  page: number;
  limit: number;
};

type TabType = {
  key: string;
  label: string;
  role: string;
};

type ProposalListType = {
  _id: string;
  building: {
    buildingName: string;
    buildingAddress: string;
    createdAt: string;
    createdBy: string;
    notes: string;
    updatedAt: string;
    _id: string;
    bluePrints: {
      bluePrintUrl: string;
      title: string;
      _id: string;
    }[];
  };
  proposals: string[];
  technicianJob: {
    jobTitle: string;

    additionalRequirement: string[];

    drawingMaterialType: string;
    logo: string[];
    notes: string;
  };

  action: () => void;
};

const tabs: TabType[] = [
  {
    key: 'technician',
    label: 'Proposal form Technician',
    role: 'technician',
  },
  // {
  //   key: 'escapePlan',
  //   label: 'Proposal from Escape Plan',
  //   role: 'escapePlan',
  // },
];

const Proposals = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const pagination = useSelector(
    (state: RootState) => state.proposalsList.pagination,
  );
  const proposalsList: ProposalListType[] = useSelector(
    (state: RootState) => state.proposalsList.data,
  );
  const getProposalsData = async (myParams: MyParamsType) => {
    try {
      await requestAPI(
        proposalsApi.getProposals({
          page: myParams.page,
          limit: myParams.limit,
          search: myParams.search ? myParams.search : '',
        }),
      );
    } catch (error) {
      console.error(error);
    }
  };

  const debouncedFunction = useCallback(
    debounce((myParams) => getProposalsData(myParams), 500),
    [],
  );

  useEffect(() => {
    getProposalsData(pagination);
  }, []);
  const activeTab: string = useSelector(Store.Selectors.proposalsActiveTab);

  const [search, setSearch] = useState('');

  const tableData: TableDataType = {
    headings: [
      // {
      //   key: 'createdDate',
      //   label: 'Date',
      // },
      {
        key: 'jobTitle',
        label: 'Job Title',
      },
      {
        key: 'proposalCount',
        label: 'Proposal Count',
        style: {
          textAlign: 'center', // Align content to the center
        },
      },
      {
        key: 'buildingName',
        label: 'Building Name',
      },
      {
        key: 'address',
        label: 'Address',
      },
      {
        key: 'actions',
        label: 'Action',
      },
    ],
    body: Array.isArray(proposalsList)
      ? proposalsList?.map((proposal, index) => {
        const getLength = Array.isArray(proposal.proposals)
          ? proposal.proposals.length
          : 0;
        return {
          key: index,
          id: proposal._id,
          // createdDate: humanReadableDate(proposal.createdAt),
          buildingName: proposal?.building?.buildingName,
          jobTitle: proposal?.technicianJob?.jobTitle,
          address: proposal?.building?.buildingAddress,
          proposalCount: getLength,
          actions: (
              <Button
                variant="secondary"
                size="md"
                onClick={() => navigate(proposal._id)}
                style={{
                  backgroundColor: theme.colors.blueLight,
                  border: `1px solid ${theme.colors.blueLight}`,
                }}
              >
                View Details
              </Button>
          ),
          style: {
            proposalCount: {
              textAlign: 'center',
            },
          },
        };
      })
      : [],
  };

  const tableDataForEscapeProposal: TableDataType = {
    headings: [
      {
        key: 'createdDate',
        label: 'Date',
      },
      {
        key: 'professionalName',
        label: 'Professional Name',
      },
      {
        key: 'jobTitle',
        label: 'Job Title',
      },
      {
        key: 'buildingName',
        label: 'Building Name',
      },
      {
        key: 'address',
        label: 'Address',
      },
      {
        key: 'actions',
        label: 'Action',
      },
    ],

    body: [
      {
        id: '1',
        createdDate: '12 aug 2023 - 12:59 am',
        professionalName: 'Nitish Rajak',

        jobTitle: '',
        buildingName: 'Kathmandu Mall',
        address: 'Putlisadak kathamandu',

        addressOfProperty: 'Narephat, Jadibuti, kathmandu',
        actions: (
          <Button
            variant="secondary"
            size="md"
            onClick={() =>
              navigate(
                VIEW_PROPOSAL_ROUTE.replace(
                  ':proposalFor',
                  tabs.find((x: TabType) => x.key === activeTab)?.role || '',
                ).replace(':proposalId', '1'),
              )
            }
            style={{
              backgroundColor: theme.colors.blueLight,
              border: `1px solid ${theme.colors.blueLight}`,
            }}
          >
            View Details
          </Button>
        ),
      },
      {
        id: '2',
        createdDate: '12 aug 2023 - 12:59 am',
        professionalName: 'Nitish Rajak',

        jobTitle: 'Evacuation plan for hotel',
        buildingName: 'Kathmandu Mall',
        address: 'Putlisadak kathamandu',

        addressOfProperty: 'Narephat, Jadibuti, kathmandu',
        actions: (
          <Button
            variant="secondary"
            size="md"
            onClick={() =>
              navigate(
                VIEW_PROPOSAL_ROUTE.replace(
                  ':proposalFor',
                  tabs.find((x: TabType) => x.key === activeTab)?.role || '',
                ).replace(':proposalId', '1'),
              )
            }
            style={{
              backgroundColor: theme.colors.blueLight,
              border: `1px solid ${theme.colors.blueLight}`,
            }}
          >
            View Details
          </Button>
        ),
      },
    ],
  };

  const handleOnSearchTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setSearch(value);
    debouncedFunction({ ...pagination, page: 1, search: value });
  };

  const handlePagination = (updatedParams: ParamsType) => {
    // setParams(updatedParams);
    getProposalsData(updatedParams);
    dispatch(Store.Actions.update('proposalsList.pagination', updatedParams));
  };

  const handleOnTabsChange = (key: string) => {
    dispatch(Store.Actions.set('proposalsActiveTab', key));
  };

  return (
    <ProposalsListingContainerStyled>
      <PageHeader
        maxWidthBreakPoint="768px"
        pageTitle={
          <Tabs
            activeKey={activeTab}
            items={tabs}
            onChange={handleOnTabsChange}
          />
        }
        handleOnSearchTextChange={handleOnSearchTextChange}
        search={search}
      />
      <div className="table-container">
        {
          {
            escapePlan: <Table tableData={tableDataForEscapeProposal} />,
            technician: <Table tableData={tableData} />,
          }[activeTab]
        }
      </div>
      <Pagination
        activePage={pagination.page}
        handlePagination={handlePagination}
        limit={pagination.limit}
        totalCount={pagination.totalData || 0}
      />
    </ProposalsListingContainerStyled>
  );
};

export default Proposals;
